import type { Api, Vehicle } from '@cruz-com/lookup'
import { baseURL, formatFetchError, getHeader } from '../util'

export async function vehicleLead(params: object): Promise<Api.Result<Vehicle.Lead[]>> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/lead/vehicle-leads?${new URLSearchParams(params as Record<string, string>)}`, {
      method: 'GET',
      headers,
      cache: 'no-store',
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
